// extracted by mini-css-extract-plugin
export var cardTitle = "_cj-1";
export var commentBubble = "_cj-e";
export var commentForm = "_cj-a";
export var commentInput = "_cj-b";
export var commentLabel = "_cj-d";
export var commentPrompt = "_cj-9";
export var csatCard = "_cj-0";
export var feedbackSection = "_cj-7";
export var starDisabled = "_cj-6";
export var starEmpty = "_cj-5";
export var starFilled = "_cj-4";
export var starWrapper = "_cj-3";
export var starsContainer = "_cj-2";
export var submittedComment = "_cj-c";
export var thankYouText = "_cj-8";